import React from 'react';

import { Table, className } from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';

import transitionStyle from 'aplazame-design-system/src/scss/transitions.module.scss';
import style from './style.module.scss';

function addHashToButton(button, slug) {
    let hasToAddHash =
        slug &&
        button.link &&
        button.link.slug &&
        button.link.slug.indexOf('#') === -1;
    if (!hasToAddHash) {
        return button;
    }

    return {
        ...button,
        externalLink: `/${button.link.slug}/#${slug}`,
        link: null,
    };
}

function addButtonToPricingTable(pricingTable, button) {
    if (!pricingTable.rows.length || !button) {
        return pricingTable;
    }

    let rowHeaders = [...pricingTable.rowHeaders];
    let rows = [...pricingTable.rows];

    rowHeaders.push([]);
    rows.push([]);

    rows[0].forEach((rowCell, i) => {
        rows[rows.length - 1].push(
            button ? (
                <ButtonComponent
                    button={
                        pricingTable.slugs && pricingTable.slugs[i]
                            ? addHashToButton(button, pricingTable.slugs[i])
                            : button
                    }
                    buttonClassName={style.button}
                />
            ) : null
        );
    });

    return {
        ...pricingTable,
        rowHeaders,
        rows,
    };
}

export default function PricingTable({
    pricingTable,
    button,
    extraClass,
    wrapperClassName,
    headBackground,
    slug,
    ...wrapperProps
}) {
    return (
        <div
            {...wrapperProps}
            {...className(`${wrapperClassName ? wrapperClassName : ''}`)}
        >
            <Table
                extraClass={
                    className(
                        `${style.table} body ${
                            button ? style['table--with-button'] : ''
                        } ${extraClass ? extraClass : ''} ${
                            transitionStyle['child-link']
                        } ${headBackground ? style['table--head-bg'] : ''}`
                    ).className
                }
                {...addButtonToPricingTable(pricingTable, button)}
            />
            {button ? (
                <ButtonComponent
                    button={slug ? addHashToButton(button, slug) : button}
                    buttonClassName={`d-lg-none ${style.button}`}
                />
            ) : null}
        </div>
    );
}
